import SectionHeading from "./SectionHeading";

type HotItem = {
  rank: number;
  title: string;
  heat: string;
  tag: string;
  delta: "up" | "down" | "new";
};

const HOT_LIST: HotItem[] = [
  { rank: 1, title: "这一届网友的总结能力有多强？评论区秒变大型颁奖现场", heat: "832.6万", tag: "神评", delta: "up" },
  { rank: 2, title: "夏日续命攻略：西瓜的正确打开方式引发南北大讨论", heat: "769.4万", tag: "热议", delta: "up" },
  { rank: 3, title: "深夜食堂治愈瞬间，网友：看着看着就饿了", heat: "655.2万", tag: "热议", delta: "new" },
  { rank: 4, title: "当程序员在弹幕里写代码，全网现场教学名场面", heat: "521.7万", tag: "围观", delta: "down" },
  { rank: 5, title: "毕业季表白合集，评论区含糖量严重超标", heat: "498.3万", tag: "讨论", delta: "up" },
  { rank: 6, title: "宠物成精名场面盘点，铲屎官集体破防", heat: "410.9万", tag: "围观", delta: "down" },
  { rank: 7, title: "外卖备注栏里的隐藏人生，每一单都是一段故事", heat: "367.5万", tag: "热议", delta: "up" },
  { rank: 8, title: "神回复挑战赛：一句话让评论区瞬间安静", heat: "302.1万", tag: "神评", delta: "new" },
  { rank: 9, title: "小时候的零食记忆，网友：都是回不去的青春", heat: "256.8万", tag: "讨论", delta: "down" },
  { rank: 10, title: "今日最佳弹幕评选：有内味了", heat: "198.4万", tag: "弹幕", delta: "up" },
];

const FEATURED = [
  {
    emoji: "🍉",
    tone: "from-primary-100 to-primary-50",
    title: "西瓜自由大赏",
    desc: "谁能拒绝一块冰镇西瓜？网友的花样吃法让你大开眼界。",
    meta: "3.2万人围观",
  },
  {
    emoji: "🙋",
    tone: "from-accent-100 to-accent-50",
    title: "你的护身符是什么",
    desc: "评论区神兽出没，快来晒出你的专属锦鲤与玄学护身符。",
    meta: "1.8万人参与",
  },
];

export default function HotBoard() {
  return (
    <section id="board" className="relative bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="今日瓜田热搜"
          title="大家都在围观什么"
          accent="热榜 TOP10"
          desc="实时更新网友最关注的热门话题，榜单每十分钟刷新一次，快来给上榜话题补一刀。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 items-start">
          <div className="lg:col-span-2">
            <ol className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {HOT_LIST.map((item) => (
                <li
                  key={item.rank}
                  className="group flex items-start gap-3 rounded-xl bg-background-50 p-3.5 ring-1 ring-background-200/70 hover:ring-primary-200 transition"
                >
                  <span
                    className={`font-heading flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-lg ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0">
                    <p className="text-[15px] leading-snug text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-2">
                      {item.title}
                    </p>
                    <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">
                        {item.tag}
                      </span>
                      <span className="whitespace-nowrap">
                        <i className="ri-fire-line mr-0.5 text-primary-500"></i>
                        {item.heat}
                      </span>
                      {item.delta === "up" && (
                        <span className="text-primary-600">
                          <i className="ri-arrow-up-line"></i>
                        </span>
                      )}
                      {item.delta === "new" && (
                        <span className="whitespace-nowrap text-secondary-600">新晋</span>
                      )}
                      {item.delta === "down" && (
                        <span className="text-foreground-400">
                          <i className="ri-arrow-down-line"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
            <div className="mt-6 flex justify-center lg:justify-start">
              <a
                href="#topics"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm text-foreground-700 ring-1 ring-background-300 hover:ring-primary-300 hover:text-primary-700 transition"
              >
                更多热议话题
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 p-5 text-background-50">
              <p className="font-heading text-2xl">今天吃点啥瓜？</p>
              <p className="mt-2 text-sm text-background-100 leading-relaxed">
                围观不是目的，开心才是。无论生活多忙，记得留一块西瓜给自己。
              </p>
              <a
                href="#danmaku"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm text-primary-700 hover:bg-background-100 transition"
              >
                去弹幕区冒个泡
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 gap-4">
              {FEATURED.map((f) => (
                <div
                  key={f.title}
                  className={`flex items-start gap-3 rounded-2xl bg-gradient-to-br ${f.tone} p-4 ring-1 ring-background-200/60`}
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-background-50/70 text-2xl">
                    {f.emoji}
                  </span>
                  <div>
                    <h3 className="text-[15px] font-semibold text-foreground-800">{f.title}</h3>
                    <p className="mt-1 text-sm leading-snug text-foreground-600">{f.desc}</p>
                    <p className="mt-2 inline-flex items-center gap-1 text-xs text-accent-700">
                      <i className="ri-eye-line"></i>
                      {f.meta}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}